import { USER_ROLES } from '@bagonboard/wiseman';
import { always } from 'ramda';
import { USER_LIST_OF_ROLES } from '#constants';

export const filterRolesToShow = (currentRole, isDisabled) => {
  const filterRoles = listToFilter => USER_LIST_OF_ROLES
    .filter(({ value }) => listToFilter.includes(value));

  if (currentRole === USER_ROLES.HANDLING_COMPANY_MANAGER) {
    const toFilter = [
      USER_ROLES.HANDLING_COMPANY_AGENT,
      USER_ROLES.HANDLING_COMPANY_OPERATOR,
      ...[isDisabled ? USER_ROLES.HANDLING_COMPANY_MANAGER : undefined],
    ];
    return filterRoles(toFilter);
  }

  if (currentRole === USER_ROLES.COURIER_ADMIN) {
    const toFilter = [
      USER_ROLES.AGENT,
      ...[isDisabled ? USER_ROLES.COURIER_ADMIN : undefined],
    ];
    return filterRoles(toFilter);
  }

  return ([USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN].includes(currentRole))
    ? USER_LIST_OF_ROLES
    : [{ value: '', text: '-- No results --' }];
};

export const mustShowPoi = (selectedRole) => {
  const LAF_USERS = [
    USER_ROLES.HANDLING_COMPANY_AGENT,
    USER_ROLES.HANDLING_COMPANY_OPERATOR,
  ];
  return LAF_USERS.includes(selectedRole);
};

export const mustShowAreas = (selectedRole) => {
  const COURIER_USERS = [
    USER_ROLES.AGENT,
    USER_ROLES.COURIER_AGENT,
  ];
  return COURIER_USERS.includes(selectedRole);
};

export const mustShowCompanies = (selectedRole, userRole) => {
  const ADMINS = [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN];
  const ROLES_NEED_COMPANY = [
    USER_ROLES.COURIER_ADMIN,
    USER_ROLES.COURIER_AGENT,
    USER_ROLES.AGENT,
    USER_ROLES.HANDLING_COMPANY_MANAGER,
    USER_ROLES.HANDLING_COMPANY_AGENT,
    USER_ROLES.HANDLING_COMPANY_OPERATOR,
    USER_ROLES.HANDLING_COMPANY_OBSERVER,
  ];
  return ROLES_NEED_COMPANY.includes(selectedRole) && ADMINS.includes(userRole);
};

export const filterCompanies = (selectedRole) => {
  const filters = {
    handling: ({ text }) => text.startsWith('HANDLING'),
    courier : ({ text }) => text.startsWith('COURIER'),
  };
  const filtersByRole = {
    [USER_ROLES.HANDLING_COMPANY_MANAGER] : filters.handling,
    [USER_ROLES.HANDLING_COMPANY_AGENT]   : filters.handling,
    [USER_ROLES.HANDLING_COMPANY_OPERATOR]: filters.handling,
    [USER_ROLES.HANDLING_COMPANY_OBSERVER]: filters.handling,
    [USER_ROLES.COURIER_ADMIN]            : filters.courier,
    [USER_ROLES.COURIER_AGENT]            : filters.courier,
    [USER_ROLES.AGENT]                    : filters.courier,
  };
  return filtersByRole[selectedRole] || always(true);
};

export default filterRolesToShow;
